import React, { useState, useEffect } from 'react';
import FormControl from 'helpers/FormControl';
import BUService from 'services/bu/service';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const BuFundRow = props => {
  const [BuOptions, setBuOptions] = useState('');
  const [formValues, setFormValues] = useState('');

  const { t } = useTranslation();

  const displayBuOptions = () => {
    let BuOptionsData = BUService.getAll();

    BuOptionsData.then(({ data }) => {
      setBuOptions(
        data.map(field => {
          return <option value={field.id}>{field.name}</option>;
        })
      );
    });
  };

  const sendFormValues = (field, value) => {
    let data = {};
    data[field] = value;
    setFormValues(data);
    props.buFundData[props.buFundRowPosition][field] = value;
  };

  const getValues = field => {
    return props.buFundData[props.buFundRowPosition][field] || '';
  };

  useEffect(() => {
    displayBuOptions();
  }, []);

  return (
    <tr>
      <td>
      <div className="mobile-hidden-table-head">{t('label:BU')}: </div>
        <FormControl
          as="select"
          value={getValues(['bu_id'])}
          validation=""
          onChange={e => sendFormValues('bu_id', e.target.value)}
        >
          <option value="" disabled>
            {t('label:select')}
          </option>
          {BuOptions}
        </FormControl>
      </td>
      <td>
      <div className="mobile-hidden-table-head">{t('label:BU verb percentage')}: </div>
        <FormControl
          value={getValues(['value'])}
          onChange={e => sendFormValues('value', e.target.value)}
        />
      </td>
      <td className="text-center">
        <div className='mobile-transform-table-card-btn'>
          <Button
            size="sm"
            variant="danger"
            className="ml-1"
            alt={t('title:delete')}
            title={t('title:delete')}
            onClick={e => props.removeBuValues(props.buFundRowPosition)}
          >
            <i className="fas fa-times"></i>
          </Button>
        </div>
      </td>
    </tr>
  );
};

export default BuFundRow;
